import React from 'react';

export function TriangleDown(props) {
    return (
        <svg viewBox="0 0 10 8" {...props}>
            <path d="M5 8l5-8H0z" fill="#537DD4" fillRule="evenodd" />
        </svg>
    );
}
